module.exports = __webpack_public_path__ + "HelveticaBoldOblique.cf0befd1fb7ab73c876e.eot";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/Helvetica/HelveticaBoldOblique.eot
// module id = ../../../../../src/app/@theme/fontes/Helvetica/HelveticaBoldOblique.eot
// module chunks = styles